module.exports = __webpack_public_path__ + "static/img/logo.4f56370e.svg";